import { apiConnector } from 'apiConnector/secondary-market/legacyApiConnector';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  secondaryMarketReferentialAstroClientFetchingFailed,
  secondaryMarketReferentialAstroClientNotFound,
} from 'state/secondaryMarket/referential/astroClient/astroClient.actions';
import { secondaryMarketReferentialAstroClientFetchedThunk } from 'state/secondaryMarket/referential/astroClient/astroClient.thunks';
import type { EpicWithThunk } from 'state/state.common';

export function loadAstroClientEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const api = apiConnector(httpClient);
    return actions$.pipe(
      ofType('SECONDARY_MARKET_REFERENTIAL_ASTRO_CLIENT_REQUESTED'),
      mergeMap(({ clientId, tabId }) =>
        api.loadAstroClient(clientId).pipe(
          map(payload => {
            if (payload === 'not_found') {
              return secondaryMarketReferentialAstroClientNotFound(clientId);
            }
            return secondaryMarketReferentialAstroClientFetchedThunk(tabId, clientId, payload);
          }),
          catchError(error => of(secondaryMarketReferentialAstroClientFetchingFailed(clientId, error?.message))),
        ),
      ),
    );
  };
}
